export default "/_next/static/images/6a/6-6abe827df2ca1d5fdac7f8a481060dff.jpg";